export default __webpack_public_path__ + "static/media/resume.79d2a603.svg";